import React, { Component } from "react";
import { connect } from "react-redux";

import {
  setCurrentNavPage,
  selectSearchWord,
  selectRole,
  setSelectedUsers
} from "Actions";
import _ from "i18n";
import { ROLE_TYPES } from "Config";
import styles from "./Authorizations.local.scss";
import classnames from "classnames";
import SidePageHeader from "../Common/SidePageHeader/SidePageHeader";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import Users from "./Users";
import Bubbles from "./Bubbles";
import Sidebar from "./SideBar";

class AuthorizationsPage extends Component {
  constructor(props) {
    super(props);
    this.roleOptions = Object.keys(ROLE_TYPES).map(roleType => {
      return {
        label: _(roleType),
        options: ROLE_TYPES[roleType].map(({ value, key }) => {
          return { label: _(value), value: key };
        })
      };
    });
    this.state = {
      settingsIsActive: false
    };
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(setCurrentNavPage("AUTHORIZATIONS_PAGE"));
  }

  // componentDidMount() {
  //   if (inIframe()) {
  //     this.deleteHeader();
  //   }
  // }

  componentWillUnmount() {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
  }

  handleSearchInputChange(word) {
    const { dispatch } = this.props;
    if (word && word.length >= 3) {
      dispatch(selectSearchWord(word));
    } else {
      dispatch(selectSearchWord(""));
    }
  }

  clearAll = () => {
    this.handleSearchInputChange("");
  };

  handleSelectRole = selected => {
    this.props.dispatch(selectRole(selected));
  };

  handleSettingsTab = isActive => {
    this.setState({
      settingsIsActive: isActive
    });
  };

  handleToggleSelectAll = () => {
    const { selectedUsers, users, dispatch } = this.props;
    if (selectedUsers.length > 0) {
      dispatch(setSelectedUsers([]));
    } else {
      dispatch(setSelectedUsers(users));
    }
  };

  // deleteHeader = () => {
  //   //  let Menu = document.getElementById("mainMenu");
  //   let subMenu = document.getElementById("subMenu");
  //
  //   // Menu && Menu.remove();
  //   subMenu && subMenu.remove();
  // };

  render() {
    let {
      filterSearchWord,
      role,
      selectedUsers,
      users,
      language,
      userType,
      withoutHeader
    } = this.props;
    let { settingsIsActive } = this.state;

    let isSelectAll =
      users.length !== 0 && selectedUsers.length === users.length;
    let isUserSelected = selectedUsers.length >= 1;

    let filters = [
      {
        grid: 5,
        type: "SELECT",
        options: {
          isSimple: true,
          isMulti: false,
          isClearable: true,
          placeholder: _("roles"),
          options: this.roleOptions,
          values: role,
          action: this.handleSelectRole
        }
      }
    ];
    return (
      <div className={classnames(styles.settings, "page-content")}>
        <SidePageHeader app="Accounting" subHeader="users" />
        <div
          className={classnames(
            styles.settings__filter_bar,
            "row align-center"
          )}
        >
          <TTPFilterHorizontalBar
            button
            filters={filters.options}
            searchInputValue={filterSearchWord}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            handleResetFilter={this.clearAll}
            searchPlaceholder="Search by name"
            cssClass={classnames("medium-12", styles.force_hide_border_search)}
            nbResult={users.length}
            label={_("userNumber")}
          />
        </div>
        <div id="setting-users" className={classnames("row align-center")}>
          <Users />
        </div>
        <Bubbles
          handleSettingsTab={this.handleSettingsTab}
          handleToggleSelectAll={this.handleToggleSelectAll}
          isSelectAll={isSelectAll}
          isUserSelected={isUserSelected}
          language={language}
          userType={userType}
          withoutHeader={withoutHeader}
        />
        <Sidebar
          settingsIsActive={settingsIsActive}
          handleSettingsTab={this.handleSettingsTab}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  filterSearchWord: state.authorizationsSettings.filter.searchWord,
  role: state.authorizationsSettings.filter.role,
  selectedUsers: state.authorizationsSettings.selectedUsers,
  users: state.authorizations.items,
  language: state.params.lng,
  userType: state.auth.user.role.type,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(AuthorizationsPage);



// WEBPACK FOOTER //
// ./src/components/Authorizations/AuthorizationsPage.js